module.exports = __webpack_public_path__ + "static/media/user-group-solid.bbc93a82.svg";